import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import HeaderStatisticsField from './HeaderStatisticsField'

function HeaderStatistics({ modelsCount, designersCount }) {
  const statisticsData = [{
    number: numeral(modelsCount).format('0a'),
    text: '3D models',
  }, {
    number: numeral(designersCount).format('0.00a').toUpperCase(),
    text: '3D designers',
  }, {
    number: '100+',
    text: 'Fortune 500 clients',
  }]

  return (
    <div className="container-fixed">
      <div className="row">
        <div className="col-12 col-lg-10 col-xl-6 offset-lg-1 offset-xl-3">
          <div className="row justify-content-center header-statistics">
            {statisticsData.map((item, i) => (
              <HeaderStatisticsField
                key={`header-statistics-element-${i}`}
                {...item}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

HeaderStatistics.propTypes = {
  modelsCount: PropTypes.number.isRequired,
  designersCount: PropTypes.number.isRequired,
}

export default HeaderStatistics
